/**
 * Page de réinitialisation du mot de passe (lien reçu par email).
 * URL : /reset-password?token=xxx
 */
import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import ResetPasswordForm from "../components/auth/ResetPasswordForm.jsx";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const handleClose = () => navigate("/auth", { replace: true });
  const handleBack = () => navigate("/auth", { replace: true });

  if (!token) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-md w-full text-center border border-white/20">
          <p className="text-white mb-4">
            Lien invalide ou expiré. Demandez un nouveau lien depuis la page de
            connexion (Mot de passe oublié).
          </p>
          <button
            type="button"
            onClick={() => navigate("/auth", { replace: true })}
            className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium"
          >
            Aller à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <ResetPasswordForm
        resetToken={token}
        onBack={handleBack}
        onClose={handleClose}
      />
    </div>
  );
}
